<template>
  <div class="page" @click="closePopup">
    <div class="mask"></div>
    <div class="popup" :class="{ cancelPos: closeFlower}">
      <lottie
        v-if="lottieShow"
        class="light-effect"
        style="width: 100%; height: 100%;"
        :options="anim_options"
        v-on:animCreated="handleAnimation"
      />
      <!-- 动画等级 -->
      <div class="level">
        <span class="level-lv longTouch">Lv.</span>
        <span class="level-level longTouch">{{ cur_level }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import Lottie from "vue-lottie/src/lottie.vue";
import loading from "@/assets/anim/ef/data.json";
import _ from "lodash";
export default {
  components:{
    'lottie': Lottie
  },
  props: {
    cur_level: {
      type: Number,
      default: 0,
    },
    isShow: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    isShow: {
      handler(value) {
        if(value)this.animInit();
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const closeFlower = ref(false);
    const isMove = ref(true);
    const anim_options = { animationData: _.cloneDeep(loading) };
    const lottieShow = ref(true);
    const animNode = ref(null);
    anim_options.animationData.assets.forEach(item => {
      // 适配动态路径
      item.u = '';
      if(item.w && item.h){
        try {
          item.p = require(`@/assets/anim/ef/images/${item.p}`);
        } catch (error) {
          console.error(error);
        }
      }
    })

    onMounted(() => {
      // animInit();
    });

    /**获取Lottie动画节点 */
    const handleAnimation = (anim) => {
      animNode.value = anim;
      // console.log('ssssssssssssssssss-lottie');
      // console.log(animNode.value);
      // // animNode.value
      // animNode.value.loop = false;
      // animNode.value.autoplay = false;
      animNode.value.stop();
      animNode.value.loop = false;
      animNode.value.play();
    }

    const animInit = () => {
      // console.log('animInit');
      lottieShow.value = true;
      
      // 动画执行完毕后等待1s，若没有监听到则自动关闭
      const animated = document.querySelector(".animated");
      if (animated) {
        animated?.addEventListener("animationend", () => {
          delayClose();
        });
      } else {
        delayClose();
      }
    }

    const delayClose = () => {
      setTimeout(() => {
        closePopup();
        lottieShow.value = false;
      }, 833.3333333);
    };

    const closePopup = () => {
      closeFlower.value = true;
      //动画执行1s后关闭
      setTimeout(() => {
        isMove.value = false;
        emit("close", false);
      }, 400);
    };
    
    return {
      closeFlower,
      closePopup,
      animInit,
      handleAnimation,
      isMove,
      anim_options,
      lottieShow
    };
  },
};
</script>

<style lang="less" scoped>
@animationTime: 450ms;

.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;
  will-change: transform;
  
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
  }
  .fade {
    // animation: Fade 0.5s forwards;
  }
  @keyframes Fade {
    0% {
      background: rgba(0, 0, 0, 0.8);
    }
    20% {
      background: rgba(0, 0, 0, 0.65);
    }
    40% {
      background: rgba(0, 0, 0, 0.50);
    }
    60% {
      background: rgba(0, 0, 0, 0.35);
    }
    80% {
      background: rgba(0, 0, 0, 0.20);
    }
    100% {
      background: rgba(0, 0, 0, 0);
    }
  }

  .cancelPos {
    position: static;
  }
  .popup {
    position: absolute;
    z-index: 9999;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;

    .level{
        z-index: 1;
        position: fixed;
        left: 50%;
        top: 49%;
        transform: translate(-50%, -50%);
        // -webkit-text-stroke: 2px #732CCD;
        text-shadow: #A72FDF 0px 0px 20px;
        font-size: 24px;
        color: #fff;
        font-weight: bold;
        font-family: "Josefin Sans Boldtalic";
        text-align: left;
        letter-spacing: -0.88px;
        animation: textSprite @animationTime forwards;
        transition: all .1s;
        @keyframes textSprite {
          0% {
            opacity: 0;
          }
          80% {
            font-size: 24px;
            // -webkit-text-stroke: 0px #732CCD;
          }
          85% {
            font-size: 44px;
            // -webkit-text-stroke: 1px #732CCD;
          }
          90% {
            font-size: 64px;
            // -webkit-text-stroke: 2px #732CCD;
          }
          100% {
            font-size: 54px;
            // -webkit-text-stroke: 2px #732CCD;
          }
        }
        &-lv{
          animation: textSpriteOpacity @animationTime forwards;
          transition: all .1s;
          margin-right: 4px;
        }
        &-level{
          animation: textSpriteOpacity @animationTime forwards;
          transition: all .1s;
        }
        @keyframes textSpriteOpacity {
          0% {
            opacity: 0;
          }
          80% {
            opacity: 0;
          }
          90% {
            opacity: 0.7;
          }
          100% {
            opacity: 1;
          }
        }
    }
  }
//json方式实现
.light-effect{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 300px;
  height: 300px;
}
}
</style>
